/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const blockedTeamPatchSchema = z.object({
  assignedItemCount: z.int(),
  currentLoopId: z.int(),
  reason: z.enum(['TEAM_HAS_ASSIGNED_ITEMS']),
  teamId: z.int(),
  teamName: z.string(),
});
